/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "E7B8A067-1850-4B18-A476-E5194524862F",
  "sitecoreApiHost": "",
  "jssAppName": "caseih",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/caseih",
  "graphQLEndpoint": "/api/caseih?sc_apikey=E7B8A067-1850-4B18-A476-E5194524862F"
};